import React from 'react'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import { useNavigate } from 'react-router-dom'

const ACButton = () => {
  const navigate = useNavigate()
  return (
    <AdxActionButton
      title="Create Appraisal"
      description="Create new appraisal to evaluate your staff performance"
      icon="track_changes"
      icon2="arrow_forward_ios"
      iconColor="alternate.main"
      iconBgColor="alternate.light"
      onClick={() => {
        navigate('/app/appraisal-cycle/create')
      }}
      actionMessage="Create"
      divClick={true}
      sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}
    />
  )
}

export default ACButton
